import { hydrate } from 'svelte'

import createEduHomeStores from '../stores/createEduHomeStores'

import DecorativeDonut from '../../components/projects/facts-and-figures/composite/DecorativeDonut.svelte'
import SoloBarChart from '../../components/projects/facts-and-figures/composite/SoloBarChart.svelte'

/**
 * Fetch data for EduHome; mount components with data stores
 */
export default function () {
  const [
    data, // the main store; will hold ALL data fetched
    loading, // will be true until the data fetching is done, can be used in components for loading state
    error, // if the fetches went completely sideways, this will be truthy, and can be used in components
    
    educationDerived,
    studentByDegreeDerived
  ] = createEduHomeStores()
  
  if(document.getElementById('edu-donut')) {
    hydrate(DecorativeDonut, {
      target: document.getElementById('edu-donut'),
      props: {
        store: educationDerived
      }
    })
  }

  if(document.getElementById('edu-red-bars')) {
    hydrate(SoloBarChart, {
      target: document.getElementById('edu-red-bars'),
      props: {
        variant: 'red', 
        store: studentByDegreeDerived
      }
    })
  }
}